import React, { useState, useEffect } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import 'react-material-symbols/rounded';
import AxiosClient from '../../assets/AxiosClient';
import wordsToRemove from './assets/wordsToRemove'; 
import wordsToReplace from './assets/wordsToReplace';
import AName from './A_Name';

const standardizeName = (name) => {
  let standardized = name.trim().toLowerCase(); // Convert to lowercase and remove leading/trailing spaces

  wordsToRemove.forEach(word => {
    standardized = standardized.replace(word, ''); // Remove the word
  });

  Object.keys(wordsToReplace).forEach(word => {
    const replacement = wordsToReplace[word];
    standardized = standardized.replace(new RegExp('\\b' + word + '\\b', 'gi'), replacement);
  });

  standardized = standardized.split(' ').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');

  return standardized;
};

const NamesProcess = () => {
  const [Attendants, setAttendants] = useState([]);
  const [updatedIndexes, setUpdatedIndexes] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (Attendants.length === 0) {
      GetAttend();
    }
  }, []);

  const GetAttend = () => {
    AxiosClient.get('ETL/Attends').then((response) => {
      setAttendants(response.data);
    });
  };

  const Transfair = () => {
    setAttendants(Attendants.map(attendant => ({
      ...attendant,
      first_name: standardizeName(attendant.first_name),
      last_name: standardizeName(attendant.last_name),
      middle_name: standardizeName(attendant.middle_name)
    })));
  };

  const Load = () => {
    const updatedIndexes = [];
    Attendants.forEach((attendant, index) => {
      AxiosClient.put(`ETL/updateAttends/${attendant.id}`, {
        first_name: standardizeName(attendant.first_name),
        last_name: standardizeName(attendant.last_name),
        middle_name: standardizeName(attendant.middle_name)
      }).then(response => {
        updatedIndexes.push(index);
        setUpdatedIndexes(updatedIndexes);
        const newProgress = ((updatedIndexes.length / Attendants.length) * 100).toFixed(2);
        setProgress(newProgress);
        // Handle success
      }).catch(error => {
        console.error('Error updating attendee:', error);
      });
    });
  };

  const ShowNames = () => {
    // Implement the logic to show the names
    // You can access the names in the `Attendants` state
    // and display them in the table
  };

  return (
    <div className="row border-top">
      <div className="col-12">
        <div className="card my-4">
          <div className="card-body px-0 pb-2">
            <div className=" p-3">
              {Attendants.length === 0 && (
                <button className="btn btn-dark m-2" onClick={GetAttend}>
                  Extract <MaterialSymbol icon="chip_extraction" size={15} className="ml-2" />
                </button>
              )}
              {Attendants.length > 0 && (
                <>
                  <button className="btn btn-danger m-2" onClick={ShowNames}>
                    <MaterialSymbol icon="ent" size={15} className="ml-2" />
                    Show
                  </button>
                  <button className="btn btn-dark m-2" onClick={Transfair}>
                  <MaterialSymbol icon="ent" size={15} className="ml-2" />

                  Transfer </button>
                  <button className="btn btn-info m-2" onClick={Load}>
                  <MaterialSymbol icon="ent" size={15} className="ml-2" />

Load</button>
                </>
              )}
            </div>
            {Attendants.length > 0 && (
              <div>
                <div className="progress mb-3">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Middle Name</th>
                      <th>Last Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Attendants.map((attendant, index) => (
                      <tr key={attendant.id} style={{ background: updatedIndexes.includes(index) ? 'lightgreen' : '' }}>
                        <td>
                          <AName name={attendant.first_name} />
                        </td>
                        <td>
                          <AName name={attendant.middle_name} />
                        </td>
                        <td>
                          <AName name={attendant.last_name} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NamesProcess;
